var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comp-main"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,class:{ 'nav-item': true, active: item.val === _vm.module },on:{"click":function($event){return _vm.itemClick(item.val)}}},[_vm._v(" "+_vm._s(item.key)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }